<script lang="ts">
    import { page } from '$app/stores';
</script>

Flirtify error page
<h1>{$page.error?.code}</h1>
{$page.error?.message}
